import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot, Resolve, RouterStateSnapshot
} from '@angular/router';
import { AuthenticationService } from 'app/helpers/authentication.service';
import { Functions } from 'app/helpers/functions';
import { ConfigVersion } from 'app/shared/config-version.service';
import { CrudService } from 'app/shared/crud-service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { RegrasDTO } from './regras.model';


@Injectable({
  providedIn: 'root'
})
export class RegrasNegociosPluguinsService extends CrudService<RegrasDTO> implements Resolve<any> {
    
    
    constructor(protected http: HttpClient,
                private _authService: AuthenticationService,
                private functions: Functions,
                private configVersion: ConfigVersion) {
      super(http, `${environment.apiAdministration}/plugins`);
            
    }   

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {}

    getPluguins(): Promise<any> {      
                               
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.apiAdministration}/plugins/listroles`).subscribe((response: any) => {  
                resolve(response);
            }, reject);
        });

    }   

    getRolesByPluguinId(id: number): Promise<any> {        

        let params = '';
        
        params = 'accountid=' + this._authService.currentUserValue.accountId + '&pluguinid=' + id;
                               
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.apiAdministration}/roles/${params}`).subscribe((response: any) => {                
                resolve(response);
            }, reject);
        });

    }

    getAccountRole(id: number): Promise<any> {        

        let params = '';
        
        params = 'accountid=' + this._authService.currentUserValue.accountId + '&role=' + id;
                               
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.apiAdministration}/account/${params}`).subscribe((response: any) => {                
                resolve(response);
            }, reject);
        });

    }

    getRolesAccountRoles(): Promise<any> {    
        let params = '';
        
        params = 'accountId=' + this._authService.currentUserValue.accountId + '&usuarioId=' + this._authService.currentUserValue.userDetails.userId;
                               
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.apiAdministration}/roles/roles-accountId-enumRoleType?${params}`).subscribe((response: any) => {                
                resolve(response);
            }, reject);
        });

    }

    getRolesAccountRolesNew(): Promise<any> {    
        let params = '';
        
        params = 'accountId=' + this._authService.currentUserValue.accountId + '&usuarioId=' + this._authService.currentUserValue.userDetails.userId;
                               
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.apiAdministration}/roles/roles-accountId-enumRoleType-new?${params}`).subscribe((response: any) => {                
                resolve(response);
            }, reject);
        });

    }

    returnAccountRoles(regra, id){
        let aux = undefined;
        regra.find(item => {
            if(item.VinculoId == id){
                aux = item.Value;
            }
        });
        return aux;
    }

    returnValueRoles(
        regras: any[],
        empresaId: number,
        userGroupId: string,
        userId: string
    ): any {
        for (const item of regras) {
            switch (item.EnumRoleType) {
                case 1:
                    return this.conversorTipo(item.Value, item.Enum);

                case 2:
                    if (Number(item.VinculoId) === empresaId) {
                        return this.conversorTipo(item.Value, item.Enum);
                    }
                    break;

                case 4:
                    if (item.VinculoId === userGroupId) {
                        return this.conversorTipo(item.Value, item.Enum);
                    }
                    break;

                case 5:
                    if (item.VinculoId === userId) {
                        return this.conversorTipo(item.Value, item.Enum);
                    }
                    break;
            }
        }

        return null;
    }


    private conversorTipo(value: string, tipo: string): string | boolean | null {
        switch (tipo) {
            case 'BOOLEAN':
                return value === 'true';

            case 'ENUM':
            case 'TEXTO':
                return value;

            default:
                return null;
        }
    }

    

} 
